<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="searchItem">
                            <el-input v-model="name" placeholder="规格名称"></el-input>
                        </div>
                        <div class="searchItem">
                            <el-select v-model="categoryUuid" clearable placeholder="平台商品分类" >
                                <el-option
                                    v-for="item in platformTypeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                      <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>添加
                                </el-button>
                            </div>
                        </div>
                        <el-table
                            v-loading="loading"
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="sort"
                                label="排序"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="规格名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="categoryName"
                                label="平台一级分类"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                                    <el-button type="text" size="small"  @click="remove(scope.row.uuid)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- 编辑+添加 -->
        <category-mange ref="categoryRefs"></category-mange>

    </div>
</template>

<script>
import {
    getShopStandardList,
    deleteShopStandard,
    typetree
} from "../../../utils/interface";
import categoryMange from './categoryMange'
    export default {
        data() {
            return {
                name: '',
                categoryUuid:'',
                tableData: [],
                platformTypeOptions: [],
                current: 1,
                pageSize: 10,
                total: 0,
                loading:false,
            }
        },
        components: {
          categoryMange
        },
        created() {
            this.platformTypetree();
            this.search();
        },
        methods: {
            resetData(){
                this.name = '';
                this.categoryUuid = '',
                this.search()
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList();
            },
            search(){
                this.current = 1;
                this.getList();
            },
            getList(){
                this.loading = true
                let params = {
                    name:this.name,
                    categoryUuid:this.categoryUuid,
                    origin:'PLATFORM',
                    storeUuid:"",
                    // interfaceType:'admin',
                    current:this.current,
                    pageSize:this.pageSize,
                }
                getShopStandardList(params).then((res)=>{
                    this.total = res.total;
                    this.tableData = res.list;
                    this.loading = false
                });
            },
            remove(uuid){
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                deleteShopStandard(uuid).then((res) => {
                    if (res.success) {
                        this.$message.success("删除成功");
                        this.getList()
                    }
                });
                }).catch(() => {})
            },

            // // 编辑
            toDialog(type,uuid){
                // this.$refs.categoryRefs.reset()
                if(type == 'edit') {
                    this.$refs.categoryRefs.init(type,uuid);
                }else if(type == 'add'){
                    this.$refs.categoryRefs.init(type,uuid);
                }
            },
            platformTypetree() {
                let params = {
                    grade: "1",
                    type: 'PLATFORM'
                }
                typetree(params).then((res) => {
                    this.platformTypeOptions = res;
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 20px;

                    /deep/ .el-input {
                        width: initial;
                        // margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                    .searchItem {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;

                    .name {
                        padding-right: 20px;
                        min-width: 100px;
                    }
                }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
                .orderListTable {
                    margin-top: 35px;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
    .sorting {
        p {
            margin: 0;
        }
        /deep/.el-radio-button--small .el-radio-button__inner {
           display: flex;
           align-items: center;
        }
        /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            background-color: #3d7fff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commodityManagement/category/category3D.vue